module.exports = __webpack_public_path__ + "static/media/9DESA8.d9851782.jpg";